module.exports = __webpack_public_path__ + "static/media/0.256c1998.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/0.png
// module id = 789
// module chunks = 0